import { makeUseVisualState as t } from "./atoms-v2994.js";
import { scrapeMotionValuesFromProps as e } from "./atoms-v21190.js";
import { createHtmlRenderState as o } from "./atoms-v21264.js";
const i = {
  useVisualState: t({
    scrapeMotionValuesFromProps: e,
    createRenderState: o
  })
};
export {
  i as htmlMotionConfig
};
